import { ReportsAnalyticalService } from 'data/services';
import { HandleReportsAnalyticalActivitiesByStudentServiceInterface } from 'domain/services';
import { makeHandleReportsAnalyticalActiviesStudents } from 'main/factories/usecases/reports/remote-handle-reports-analytical.activities-students-factory';

export const makeHandleReportsAnalytical =
  (): HandleReportsAnalyticalActivitiesByStudentServiceInterface => {
    return new ReportsAnalyticalService(
      makeHandleReportsAnalyticalActiviesStudents(),
    );
  };
